import SettingsMiddleware from 'pages/settings/middleware';
import OperationGridMiddleware from 'components/operation-grid/middleware';
import MainMiddleWare from 'components/main/middleware';
import ClearListMiddleware from 'components/clear-list/middleware';
import LoginMiddleware from 'pages/login/middleware';
import DeviceRegistrationMiddleware from 'pages/device-registration/middleware';
import ConnectionStatusMiddleware from 'components/connection-status/middleware';
import UsersMiddleware from 'pages/users/middleware';
import AuditLogsMiddleware from 'components/audit-logs/middleware';
import TermsMiddleware from 'pages/terms-of-use/middleware';
import DeviceInfoMiddleware from 'pages/device-info/middleware';
import UserProfileMiddleware from 'pages/user-profile/middleware';
import UserManagementMiddleare from 'pages/user-management/middleware';
import NotificationMiddleware from 'components/notification/middleware';

// IMPORTANT: SettingsMiddleware should be listed first because it controls
//  the language changing. If another middleware is listed before it, then
//  it can get triggered before the language has been set
export const appMiddleware = [
  SettingsMiddleware,
  OperationGridMiddleware,
  MainMiddleWare,
  ClearListMiddleware,
  LoginMiddleware,
  DeviceRegistrationMiddleware,
  ConnectionStatusMiddleware,
  UsersMiddleware,
  AuditLogsMiddleware,
  TermsMiddleware,
  DeviceInfoMiddleware,
  UserProfileMiddleware,
  UserManagementMiddleare,
  NotificationMiddleware
];


// WEBPACK FOOTER //
// ./src/pages/app/middleware.ts